import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Select, Button } from 'components'
import styles from './index.module.css'

const HomeDetailSale = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pt_0">
					<div className="flex-justify_end">
						<span className="link-top" style={{ color: "#999" }}>수정</span>
					</div>
					<div className={`${styles["home-address"]} pt_30`}>
						경기 성남시 분당구 판교역로 235<i className="icon icon_copy ml_5" />
					</div>
					<div className={`${styles["home-title"]} mt_5`}>에이치스퀘어 엔동</div>
					<div className={`${styles["tag-area"]} mt_10`}>
						<i className="tag tag-box tag-gray normal">아파트</i>
						<i className="tag tag-box tag-gray normal">매매</i>
					</div>
					<div className={`${styles["home-price"]} mt_20`}>7억 3,500만원</div>
					<hr className="my_40" />
					<div className={styles["list-item"]}>
						<div>
							<span>전용면적</span>
							<span>76.26㎡</span>
						</div>
					</div>
				</div>
			</div>

			<div className="shadow">
				<div className="padding">
					<h3>최근 1년간 실거래</h3>
					<Select title="전용면적 선택" className="mt_30 auto" style={{ borderBottom: 0, height: "3rem", lineHeight: "3rem" }} selected={1} data={[
						{ key: "76.26㎡", value: 0 },
						{ key: "97.94㎡", value: 1 },
						{ key: "107.95㎡", value: 2 },
						{ key: "170.69㎡", value: 3 },
					]} onSelect={(key, value) => {
						console.log(key, value)
					}}>
					</Select>
					<div className={`${styles["recent-price"]} mt_30`}>10억 ~ 10억 3,000만원</div>

					{/* 그래프 영역 */}
					<div className="mt_40" style={{ height: "17rem", background: "#f5f5f5" }}></div>

					{/* 데이터 없을 때 */}
					<div className="center-cont py_50">
						<i className="icon icon_no_data" />
						<p className="mt_20">우리 집에 최근 1년 동안<br />거래가 일어나지 않았어요.</p>
					</div>
				</div>
			</div>

			<div className="shadow">
				<div className="py_30">
					<div className={styles["transaction-list"]}>
						<div>
							<p className={styles.date}>10월 25일 (월)</p>
							<ul className="list-bg">
								<li>
									<div className={styles.info}>
										<span>10층</span>
										<span>76.26㎡</span>
									</div>
									<div className={styles.price}>8억 7,500만원</div>
								</li>
								<li>
									<div className={styles.info}>
										<span>5층</span>
										<span>76.26㎡</span>
									</div>
									<div className={styles.price}>8억 7,500만원</div>
								</li>
							</ul>
						</div>
						<div>
							<p className={styles.date}>10월 10일 (일)</p>
							<ul className="list-bg">
								<li>
									<div className={styles.info}>
										<span>10층</span>
										<span>76.26㎡</span>
									</div>
									<div className={styles.price}>8억 7,500만원</div>
								</li>
							</ul>
						</div>
						<div>
							<p className={styles.date}>3월 5일 (화)</p>
							<ul className="list-bg">
								<li>
									<div className={styles.info}>
										<span>10층</span>
										<span>76.26㎡</span>
									</div>
									<div className={styles.price}>8억 7,500만원</div>
								</li>
							</ul>
						</div>
						<div>
							<p className={styles.date}>3월 5일 (화)</p>
							<ul className="list-bg">
								<li>
									<div className={styles.info}>
										<span>10층</span>
										<span>76.26㎡</span>
									</div>
									<div className={styles.price}>8억 7,500만원</div>
								</li>
							</ul>
						</div>
					</div>
					<div className="padding pb_0">
						<Button className="btn btn--big btn-more">+ 더보기</Button>
					</div>
				</div>
			</div>

			<div className="padding pb_20">
				<h3>우리동네 최근 3개월 실거래</h3>
			</div>
			<ul className={`${styles["recent-transaction-list"]} list-bg`}>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
				<li>
					<div>
						<p>거평프리젠</p>
						<span className="mt_10">10억원 ~ 10억 3,000만원</span>
					</div>
					<i className="icon icon_arrow_sm right ml_10" />
				</li>
			</ul>

			{/* 데이터 없을 때 */}
			<div className="center-cont py_50">
				<i className="icon icon_no_data" />
				<p className="mt_20">우리 동네에 최근 3개월 동안<br />거래가 일어나지 않았어요.</p>
			</div>
		</div>
	)
}

export default HomeDetailSale